/**
 * XTRA 浮层（竖向栈，对齐 Skyrover）
 * - Klaviyo：rAF 每帧锚定 Sign Up 圆钮上缘，客服 FAB 与其保持固定间距同步上移
 * - Zendesk：启动器、主动消息和桌面弹窗跟随同一栈位；Avada Chatty 仅保留兼容清理
 */
(function () {
  var KL_CLASS = 'has-xtra-kl-teaser';
  var FOLLOW_CLASS = 'is-xtra-teaser-following';
  var ZENDESK_OPEN_CLASS = 'is-xtra-zendesk-chat-open';
  var PROACTIVE_LIFT_CLASS = 'xtra-zendesk-proactive-lift';
  var syncTimer;
  var resizeObserver = null;
  var lastTeaserEl = null;
  var followRaf = 0;
  var followEl = null;
  var lastFaqBottom = -1;
  var zendeskStackRaf = 0;
  var zendeskLauncherMo = null;
  var zendeskLauncherBound = null;
  var zendeskApplying = false;
  var zendeskMessengerBound = false;
  var zendeskDeepLinkOpened = false;
  var lastZendeskBaseline = -1;
  var zendeskPanelBottom =
    'calc(var(--xtra-float-faq-button-bottom) + var(--xtra-float-zendesk-launcher-h) + var(--xtra-float-stack-gap))';
  var zendeskPanelMaxH =
    'calc(100dvh - 12px - env(safe-area-inset-top, 0px) - var(--xtra-float-faq-button-bottom) - var(--xtra-float-zendesk-launcher-h) - var(--xtra-float-stack-gap))';

  function readCssPx(name, fallback) {
    var v = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
    var n = parseFloat(v);
    return isNaN(n) ? fallback : n;
  }

  function cssVar(name, fallback) {
    var v = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
    return v || fallback;
  }

  function visible(el) {
    return !!(el && (el.offsetParent !== null || (el.getClientRects && el.getClientRects().length)));
  }

  function findKlaviyoTeaserEl() {
    var strict = document.querySelector(
      'body div.needsclick[class*="kl-teaser"], body div[class*="kl-teaser-"]'
    );
    if (strict && visible(strict)) return strict;
    var nodes = document.querySelectorAll(
      'body a[class*="kl-"], body button[class*="kl-"], body div[class*="kl-"]'
    );
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var c = (el.className && el.className.toString()) || '';
      if (c.indexOf('teaser') === -1 && c.indexOf('Teaser') === -1) continue;
      if (!visible(el)) continue;
      var cs = getComputedStyle(el);
      if (cs.position === 'fixed') return el;
    }
    return null;
  }

  function findTeaserCircleEl(root) {
    if (!root) return null;
    var candidates = root.querySelectorAll('[role="button"], div, button, a, span');
    var best = null;
    var bestScore = 0;

    for (var i = 0; i < candidates.length; i++) {
      var node = candidates[i];
      var t = (node.textContent || '').replace(/\s+/g, ' ').trim();
      if (!/sign\s*up/i.test(t) || t.length > 24) continue;
      if (node.offsetWidth < 40 || node.offsetHeight < 40) continue;

      var cs = getComputedStyle(node);
      var w = node.offsetWidth;
      var h = node.offsetHeight;
      var score = Math.min(w, h);
      if (Math.abs(w - h) <= 12) score += 40;
      if (parseFloat(cs.borderRadius) >= Math.min(w, h) * 0.35) score += 30;
      if (cs.display === 'flex' || cs.display === 'inline-flex') score += 10;
      if (score > bestScore) {
        bestScore = score;
        best = node;
      }
    }

    return best;
  }

  /** 主题 body line-height 1.6 会让 Klaviyo 圆形 teaser 两行文案偏上并被 overflow 裁切 */
  function fixKlaviyoTeaserText(root) {
    var best = findTeaserCircleEl(root);
    if (!best) return;

    best.style.setProperty('display', 'flex', 'important');
    best.style.setProperty('flex-direction', 'column', 'important');
    best.style.setProperty('align-items', 'center', 'important');
    best.style.setProperty('justify-content', 'center', 'important');
    best.style.setProperty('text-align', 'center', 'important');
    best.style.setProperty('line-height', '1.05', 'important');
    best.style.setProperty('overflow', 'visible', 'important');
    best.style.setProperty('box-sizing', 'border-box', 'important');

    var textNodes = best.querySelectorAll('span, p, div');
    for (var j = 0; j < textNodes.length; j++) {
      var tn = textNodes[j];
      if (tn === best || !(tn.textContent || '').trim()) continue;
      tn.style.setProperty('line-height', '1.05', 'important');
      tn.style.setProperty('text-align', 'center', 'important');
    }
  }

  /** 每帧把客服 bottom 锚在 Sign Up 圆钮上缘 + 固定间距，与 Klaviyo transform 完全同步 */
  function applyFaqFollowTeaser(el) {
    var root = document.documentElement;
    var anchor = findTeaserCircleEl(el) || el;
    var r = anchor.getBoundingClientRect();
    var vh = window.innerHeight;
    var gap = readCssPx('--xtra-float-gap-teaser-to-faq', 12);
    var cornerBottom = readCssPx('--xtra-float-corner-bottom', 18);
    var faqBottom = cornerBottom;

    if (r.bottom > 0 && r.top < vh) {
      faqBottom = Math.max(cornerBottom, Math.ceil(vh - r.top + gap));
    }

    if (faqBottom === lastFaqBottom) return;
    lastFaqBottom = faqBottom;
    root.style.setProperty('--xtra-float-faq-button-bottom', faqBottom + 'px');
    scheduleBumpFaqPanels();
    scheduleZendeskStackSync();
  }

  function stopTeaserFollow() {
    followEl = null;
    lastFaqBottom = -1;
    if (followRaf) {
      cancelAnimationFrame(followRaf);
      followRaf = 0;
    }
    document.documentElement.classList.remove(FOLLOW_CLASS);
  }

  function startTeaserFollow(el) {
    if (!el) return;
    followEl = el;
    document.documentElement.classList.add(FOLLOW_CLASS);
    if (followRaf) return;

    function tick() {
      if (!followEl || !visible(followEl)) {
        stopTeaserFollow();
        return;
      }
      applyFaqFollowTeaser(followEl);
      followRaf = requestAnimationFrame(tick);
    }

    followRaf = requestAnimationFrame(tick);
  }

  function resetTeaserStackVars() {
    var root = document.documentElement;
    root.classList.remove(KL_CLASS);
    root.classList.remove(FOLLOW_CLASS);
    root.style.removeProperty('--xtra-float-faq-button-bottom');
    root.style.removeProperty('--xtra-float-teaser-measured-h');
  }

  function bindResizeObserver(el) {
    if (typeof ResizeObserver === 'undefined') return;
    if (el === lastTeaserEl && resizeObserver) return;
    if (resizeObserver) {
      resizeObserver.disconnect();
      resizeObserver = null;
    }
    lastTeaserEl = el;
    resizeObserver = new ResizeObserver(function () {
      fixKlaviyoTeaserText(el);
    });
    resizeObserver.observe(el);
  }

  function syncKlaviyoTeaser() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(function () {
      var root = document.documentElement;
      var el = findKlaviyoTeaserEl();
      if (!el) {
        stopTeaserFollow();
        resetTeaserStackVars();
        if (resizeObserver) {
          resizeObserver.disconnect();
          resizeObserver = null;
        }
        lastTeaserEl = null;
        scheduleBumpFaqPanels();
        scheduleZendeskStackSync();
        return;
      }
      root.classList.add(KL_CLASS);
      fixKlaviyoTeaserText(el);
      applyFaqFollowTeaser(el);
      bindResizeObserver(el);
      startTeaserFollow(el);
    }, 50);
  }

  if (typeof MutationObserver !== 'undefined') {
    var mo = new MutationObserver(syncKlaviyoTeaser);
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncKlaviyoTeaser);
  } else {
    syncKlaviyoTeaser();
  }

  var pollUntil = Date.now() + 90000;
  var poll = setInterval(function () {
    syncKlaviyoTeaser();
    initZendesk();
    if (Date.now() > pollUntil) clearInterval(poll);
  }, 800);

  var resizeT;
  window.addEventListener(
    'resize',
    function () {
      clearTimeout(resizeT);
      resizeT = setTimeout(function () {
        syncKlaviyoTeaser();
        scheduleBumpFaqPanels();
        initZendesk();
      }, 100);
    },
    { passive: true }
  );

  function scheduleZendeskStackSync() {
    cancelAnimationFrame(zendeskStackRaf);
    zendeskStackRaf = requestAnimationFrame(function () {
      zendeskStackRaf = 0;
      bumpZendeskProactiveLift();
      bumpZendeskMessagingPanels();
    });
  }

  function stackMotionTransition() {
    if (document.documentElement.classList.contains(FOLLOW_CLASS)) return 'none';
    var dur = cssVar('--xtra-float-stack-motion-duration', '420ms');
    var ease = cssVar(
      '--xtra-float-stack-motion-easing',
      'cubic-bezier(0.22, 0.92, 0.28, 1)'
    );
    return 'bottom ' + dur + ' ' + ease + ', max-height ' + dur + ' ' + ease;
  }

  function isZendeskLauncher(el) {
    if (!el || el.tagName !== 'IFRAME') return false;
    if (el.id === 'launcher') return true;
    var title = el.getAttribute('title') || '';
    return /launch messaging|启动消息传送窗口的按钮|消息传送窗口的按钮/i.test(title);
  }

  function isZendeskMessagingPanel(el) {
    if (!el || el.tagName !== 'IFRAME') return false;
    if (isZendeskLauncher(el)) return false;
    var title = el.getAttribute('title') || '';
    if (/消息传送窗口|Messaging window/i.test(title)) return true;
    return /Messaging/i.test(title) && (el.offsetHeight > 120 || el.offsetWidth > 200);
  }

  function readZendeskLauncherZIndex() {
    if (document.documentElement.classList.contains(ZENDESK_OPEN_CLASS)) {
      return cssVar('--xtra-float-z-zendesk-launcher-open', '2147483649');
    }
    return cssVar('--xtra-float-z-zendesk-launcher', '2147483646');
  }

  function isZendeskChatOpenHeuristic() {
    var panel = document.querySelector(
      'iframe[title="消息传送窗口"], iframe[title="Messaging window"]'
    );
    if (!panel) return false;
    var r = panel.getBoundingClientRect();
    return r.width > 200 && r.height > 200;
  }

  function setZendeskChatOpen(open) {
    document.documentElement.classList.toggle(ZENDESK_OPEN_CLASS, !!open);
    var launcher = document.getElementById('launcher');
    if (!launcher) return;
    launcher.style.setProperty('z-index', readZendeskLauncherZIndex(), 'important');
    launcher.style.setProperty('pointer-events', 'auto', 'important');
  }

  function syncZendeskChatOpenState() {
    setZendeskChatOpen(isZendeskChatOpenHeuristic());
  }

  function readZendeskBaselinePx() {
    return readCssPx(
      '--xtra-float-zendesk-base-bottom',
      readCssPx('--xtra-float-corner-bottom', 18)
    );
  }

  function applyZendeskBaselineOffset(force) {
    if (typeof window.zE !== 'function') return;
    var vertical = readZendeskBaselinePx();
    if (!force && Math.abs(vertical - lastZendeskBaseline) < 1) return;
    lastZendeskBaseline = vertical;

    try {
      window.zE('messenger:set', 'customization', {
        common: { hideHeader: false },
        position: {
          side: 'right',
          offset: {
            web: { horizontal: 18, vertical: vertical },
            mobile: { horizontal: 18, vertical: vertical },
          },
        },
      });
    } catch (e) {}
  }

  function isZendeskProactiveChrome(el) {
    if (!el || el.tagName !== 'IFRAME') return false;
    var src = el.getAttribute('src') || '';
    if (
      el.id === 'PBarNextFrame' ||
      el.closest('#PBarNextFrameWrapper') ||
      /shopifycloud\/preview-bar/i.test(src)
    ) {
      return false;
    }
    if (isZendeskLauncher(el) || isZendeskMessagingPanel(el)) return false;
    if (!visible(el)) return false;

    var r = el.getBoundingClientRect();
    if (r.width < 8 || r.height < 8) return false;

    var title = el.getAttribute('title') || '';
    if (/close|dismiss|proactive|message|messenger|消息|关闭/i.test(title)) return true;
    if (/zdassets|zendesk|messenger/i.test(src)) return true;

    var launcher = document.getElementById('launcher');
    if (!launcher) return false;
    var lr = launcher.getBoundingClientRect();
    if (!lr.width || !lr.height) return false;

    var stackRight = lr.right;
    var stackLeft = stackRight - 380;
    var inStackColumn = r.right >= stackLeft && r.right <= stackRight + 20;
    var aboveLauncher = r.bottom >= lr.top - 420 && r.bottom <= lr.bottom + 56;
    return inStackColumn && aboveLauncher;
  }

  function startProactiveLiftBurst(duration) {
    var until = Date.now() + (duration || 2400);
    function tick() {
      bumpZendeskProactiveLift();
      if (Date.now() < until) requestAnimationFrame(tick);
    }
    tick();
  }

  function bumpZendeskProactiveLift() {
    var chatOpen =
      document.documentElement.classList.contains(ZENDESK_OPEN_CLASS) ||
      isZendeskChatOpenHeuristic();

    document.querySelectorAll('iframe').forEach(function (el) {
      var tagged = el.classList.contains(PROACTIVE_LIFT_CLASS);
      if (!isZendeskProactiveChrome(el) || chatOpen) {
        if (tagged) el.classList.remove(PROACTIVE_LIFT_CLASS);
        return;
      }
      el.classList.add(PROACTIVE_LIFT_CLASS);
    });
  }

  function bindZendeskMessengerEvents() {
    if (zendeskMessengerBound || typeof window.zE !== 'function') return;

    window.zE(function () {
      zendeskMessengerBound = true;
      try {
        applyZendeskBaselineOffset(true);
        window.zE('messenger:on', 'open', function () {
          setZendeskChatOpen(true);
          scheduleZendeskStackSync();
        });
        window.zE('messenger:on', 'close', function () {
          setZendeskChatOpen(false);
          initZendesk();
        });
        window.zE('messenger:on', 'proactiveMessageDisplayed', function () {
          applyZendeskBaselineOffset(true);
          startProactiveLiftBurst(2600);
        });
      } catch (e) {}
    });
  }

  function openZendeskDeepLink() {
    if (zendeskDeepLinkOpened || typeof window.zE !== 'function') return;
    if (new URLSearchParams(window.location.search).get('openZendesk') !== '1') return;

    zendeskDeepLinkOpened = true;
    try {
      window.zE('messenger', 'open');
    } catch (e) {
      zendeskDeepLinkOpened = false;
    }
  }

  function applyZendeskLauncherVisuals(launcher) {
    if (zendeskApplying || !launcher) return;
    zendeskApplying = true;

    var renderSize = readCssPx('--xtra-float-zendesk-launcher-render-h', 64);
    var visualSize = readCssPx('--xtra-float-zendesk-launcher-h', 50);
    var scale = visualSize / renderSize;
    var renderPx = renderSize + 'px';

    launcher.style.removeProperty('inset');
    launcher.style.removeProperty('top');
    launcher.style.removeProperty('left');
    launcher.style.removeProperty('right');
    launcher.style.removeProperty('transition');
    launcher.style.setProperty('width', renderPx, 'important');
    launcher.style.setProperty('height', renderPx, 'important');
    launcher.style.setProperty('min-width', renderPx, 'important');
    launcher.style.setProperty('min-height', renderPx, 'important');
    launcher.style.setProperty('max-width', renderPx, 'important');
    launcher.style.setProperty('max-height', renderPx, 'important');
    launcher.style.setProperty('border-radius', '50%', 'important');
    launcher.style.setProperty('overflow', 'hidden', 'important');
    launcher.style.setProperty('border', '0', 'important');
    launcher.style.setProperty('box-sizing', 'border-box', 'important');
    launcher.style.setProperty('transform', 'scale(' + scale + ')', 'important');
    launcher.style.setProperty('transform-origin', 'bottom right', 'important');
    launcher.style.setProperty('z-index', readZendeskLauncherZIndex(), 'important');
    launcher.style.setProperty('pointer-events', 'auto', 'important');

    zendeskApplying = false;
  }

  function attachZendeskLauncherObserver(launcher) {
    if (!launcher || launcher === zendeskLauncherBound) return;
    if (zendeskLauncherMo) {
      zendeskLauncherMo.disconnect();
      zendeskLauncherMo = null;
    }
    zendeskLauncherBound = launcher;
    zendeskLauncherMo = new MutationObserver(function () {
      if (zendeskApplying) return;
      applyZendeskLauncherVisuals(launcher);
    });
    zendeskLauncherMo.observe(launcher, { attributes: true, attributeFilter: ['style'] });
  }

  function initZendesk() {
    bindZendeskMessengerEvents();
    applyZendeskBaselineOffset(false);
    openZendeskDeepLink();

    var launcher = document.getElementById('launcher');
    if (launcher) {
      applyZendeskLauncherVisuals(launcher);
      attachZendeskLauncherObserver(launcher);
    }

    syncZendeskChatOpenState();
    scheduleZendeskStackSync();
  }

  function bumpZendeskMessagingPanels() {
    var isDesktop =
      typeof window.matchMedia === 'function'
        ? window.matchMedia('(min-width: 769px)').matches
        : window.innerWidth > 768;
    var motion = stackMotionTransition();
    var panelZ = cssVar('--xtra-float-z-zendesk-panel', '2147483648');
    var chatOpen =
      document.documentElement.classList.contains(ZENDESK_OPEN_CLASS) ||
      isZendeskChatOpenHeuristic();

    document.querySelectorAll('iframe').forEach(function (el) {
      if (!isZendeskMessagingPanel(el)) return;
      el.style.setProperty('z-index', panelZ, 'important');
      if (!isDesktop || !chatOpen) {
        syncZendeskChatOpenState();
        return;
      }

      el.style.removeProperty('inset');
      el.style.setProperty('right', 'var(--xtra-float-corner-right)', 'important');
      el.style.setProperty('left', 'auto', 'important');
      el.style.setProperty('bottom', zendeskPanelBottom, 'important');
      el.style.setProperty('top', 'auto', 'important');
      el.style.setProperty('max-height', zendeskPanelMaxH, 'important');
      if (motion === 'none') {
        el.style.setProperty('transition', 'none', 'important');
      } else {
        el.style.removeProperty('transition');
      }
    });

    var webWidget = document.getElementById('webWidget');
    if (!webWidget) return;

    webWidget.style.setProperty(
      'z-index',
      chatOpen ? panelZ : readZendeskLauncherZIndex(),
      'important'
    );
    if (!isDesktop || !chatOpen) return;

    webWidget.style.setProperty('right', 'var(--xtra-float-corner-right)', 'important');
    webWidget.style.setProperty('left', 'auto', 'important');
    webWidget.style.setProperty('bottom', zendeskPanelBottom, 'important');
    webWidget.style.setProperty('top', 'auto', 'important');
    webWidget.style.setProperty('max-height', zendeskPanelMaxH, 'important');
    if (motion === 'none') {
      webWidget.style.setProperty('transition', 'none', 'important');
    } else {
      webWidget.style.removeProperty('transition');
    }
  }

  /* ========== Avada 大会话窗 bump（桌面） ========== */

  var faqPanelPatched = new WeakSet();
  var bumpRaf = 0;
  var faqMo = null;
  var faqPanelScrollGeneration = 0;
  var faqPanelScrollDoneAtGen = typeof WeakMap !== 'undefined' ? new WeakMap() : null;

  /** 打开对话窗后把内部可滚区域滚到底（滑块在轨道下方）；原 Skyrover 为滚顶故滑块会停在最上 */
  function scrollSubtreeToBottom(root) {
    if (!root || root.scrollTop === undefined) return;
    var list = [root];
    try {
      root.querySelectorAll('*').forEach(function (n) {
        list.push(n);
      });
    } catch (e) {
      return;
    }
    list.forEach(function (node) {
      if (!node || node.scrollTop === undefined) return;
      try {
        if (node.scrollHeight <= node.clientHeight + 1) return;
        var oy = getComputedStyle(node).overflowY;
        if (oy === 'auto' || oy === 'scroll' || oy === 'overlay') {
          node.scrollTop = node.scrollHeight - node.clientHeight;
        }
      } catch (e2) {}
    });
    try {
      if (root.scrollHeight > root.clientHeight + 1) {
        root.scrollTop = root.scrollHeight - root.clientHeight;
      }
    } catch (e3) {}
  }

  function maybeScrollPanelToBottom(el) {
    if (!faqPanelScrollDoneAtGen || !matchLargeFixedFaqPanel(el)) return;
    if (faqPanelScrollDoneAtGen.get(el) === faqPanelScrollGeneration) return;
    faqPanelScrollDoneAtGen.set(el, faqPanelScrollGeneration);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        scrollSubtreeToBottom(el);
        setTimeout(function () {
          scrollSubtreeToBottom(el);
        }, 200);
      });
    });
  }

  function panelLooksBottomDocked(el) {
    var r = el.getBoundingClientRect();
    return r.bottom > window.innerHeight - 140;
  }

  function classHintsAvadaOrChatty(el) {
    var c = (el.className && el.className.toString()) || '';
    return /Avada|chatty|Chatty|Faqs|FAQ/i.test(c);
  }

  function matchLargeFixedFaqPanel(el) {
    if (!el || el.nodeType !== 1) return false;
    if (el.closest('.Avada-Faqs_Button')) return false;
    if (el.closest('.Avada-FaqsWelcomePopup')) return false;
    if (el.tagName === 'IFRAME') return false;
    if (!classHintsAvadaOrChatty(el)) return false;
    var cs = getComputedStyle(el);
    if (cs.position !== 'fixed') return false;
    if (el.offsetWidth < 260 || el.offsetHeight < 220) return false;
    return true;
  }

  function bumpFaqChatPanels() {
    if (typeof window.matchMedia === 'function') {
      if (!window.matchMedia('(min-width: 769px)').matches) return;
    } else if (window.innerWidth <= 768) {
      return;
    }

    var panelRight = 'var(--xtra-float-corner-right)';
    var bottomFinal = 'var(--xtra-float-faq-chat-panel-sum)';
    var topSafe = 'calc(12px + env(safe-area-inset-top, 0px))';
    var maxH =
      'calc(100dvh - 12px - env(safe-area-inset-top, 0px) - var(--xtra-float-faq-chat-panel-sum))';

    function applyOne(el) {
      if (!matchLargeFixedFaqPanel(el)) return;
      var firstPaint = !faqPanelPatched.has(el) && panelLooksBottomDocked(el);
      if (firstPaint) el.style.setProperty('opacity', '0', 'important');
      el.style.setProperty('top', topSafe, 'important');
      el.style.setProperty('bottom', bottomFinal, 'important');
      el.style.setProperty('right', panelRight, 'important');
      el.style.setProperty('left', 'auto', 'important');
      el.style.setProperty('height', 'auto', 'important');
      el.style.setProperty('min-height', '0', 'important');
      el.style.setProperty('max-height', maxH, 'important');
      el.style.setProperty('box-sizing', 'border-box', 'important');
      el.style.setProperty('overflow-y', 'auto', 'important');
      if (firstPaint) {
        void el.offsetHeight;
        requestAnimationFrame(function () {
          el.style.removeProperty('opacity');
          faqPanelPatched.add(el);
          maybeScrollPanelToBottom(el);
        });
      } else {
        maybeScrollPanelToBottom(el);
      }
    }

    var faqRoot = document.getElementById('Avada-FAQ_Widget');
    if (faqRoot) faqRoot.querySelectorAll('*').forEach(applyOne);
    if (document.body) {
      for (var i = 0; i < document.body.children.length; i++) {
        var ch = document.body.children[i];
        if (!classHintsAvadaOrChatty(ch)) continue;
        if (matchLargeFixedFaqPanel(ch)) applyOne(ch);
        ch.querySelectorAll('*').forEach(applyOne);
      }
    }
  }

  function scheduleBumpFaqPanels() {
    cancelAnimationFrame(bumpRaf);
    bumpRaf = requestAnimationFrame(function () {
      bumpFaqChatPanels();
      requestAnimationFrame(bumpFaqChatPanels);
    });
  }

  function attachFaqPanelObserver() {
    var faq = document.getElementById('Avada-FAQ_Widget');
    if (!faq || faqMo) return;
    faqMo = new MutationObserver(function () {
      scheduleBumpFaqPanels();
    });
    faqMo.observe(faq, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachFaqPanelObserver);
  } else {
    attachFaqPanelObserver();
  }

  if (typeof MutationObserver !== 'undefined' && !document.getElementById('Avada-FAQ_Widget')) {
    var faqRootWait = new MutationObserver(function () {
      if (document.getElementById('Avada-FAQ_Widget')) {
        attachFaqPanelObserver();
        faqRootWait.disconnect();
      }
    });
    faqRootWait.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () {
      faqRootWait.disconnect();
    }, 60000);
  }

  document.addEventListener(
    'click',
    function (e) {
      if (!e.target || !e.target.closest) return;
      if (!e.target.closest('#Avada-FAQ_WidgetTrigger, [data-chatty-widget="trigger"]')) return;
      faqPanelScrollGeneration += 1;
      attachFaqPanelObserver();
      scheduleBumpFaqPanels();
      queueMicrotask(bumpFaqChatPanels);
      var n = 0;
      function burst() {
        bumpFaqChatPanels();
        if (++n < 20) requestAnimationFrame(burst);
      }
      requestAnimationFrame(burst);
    },
    true
  );

  initZendesk();

  if (typeof MutationObserver !== 'undefined' && !document.getElementById('launcher')) {
    var zendeskLauncherWait = new MutationObserver(function () {
      if (document.getElementById('launcher')) {
        initZendesk();
        zendeskLauncherWait.disconnect();
      }
    });
    zendeskLauncherWait.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () {
      zendeskLauncherWait.disconnect();
    }, 90000);
  }

  scheduleBumpFaqPanels();
  scheduleZendeskStackSync();
})();
